module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_blank-aa1906ef9408c5e86ae20f58baae4e72.png";